module.exports = {
  "dof-card": {
    "overflow": "hidden",
    "position": "relative"
  },
  "dof-card--active": {
    "backgroundColor": "#f2f2f2"
  },
  "dof-card-header": {
    "position": "relative",
    "flexDirection": "row",
    "alignItems": "center",
    "overflow": "hidden"
  },
  "dof-card-header-tag": {
    "position": "absolute",
    "width": "90",
    "height": "90",
    "right": "-45",
    "top": "-45",
    "transformOrigin": "center",
    "transform": "rotateZ(45deg)"
  },
  "dof-card-header-tag-confirm": {
    "position": "absolute",
    "width": "66",
    "height": "66",
    "left": "11",
    "top": "58",
    "transformOrigin": "center",
    "transform": "rotateZ(-45deg)"
  },
  "dof-card-header-tag-confirm-colmo": {
    "position": "absolute",
    "width": "18",
    "height": "18",
    "left": "35",
    "top": "66",
    "transformOrigin": "center",
    "transform": "rotateZ(-45deg)"
  },
  "dof-card-header-stamp": {
    "position": "absolute",
    "top": "0",
    "width": "48",
    "height": "48",
    "overflow": "hidden",
    "zIndex": 100
  },
  "dof-card-header-stamp--left": {
    "left": "0",
    "borderTopLeftRadius": "32"
  },
  "dof-card-header-stamp--right": {
    "right": "0",
    "borderTopRightRadius": "32"
  },
  "dof-card-header-content": {
    "flex": 1,
    "flexDirection": "column"
  },
  "dof-card-header-arrow-wrapper": {
    "marginRight": "4"
  },
  "dof-card-header-arrow": {
    "width": "40",
    "height": "40"
  },
  "dof-card-body": {
    "position": "relative",
    "overflow": "hidden"
  },
  "dof-card-dot": {
    "position": "absolute",
    "width": "16",
    "height": "16",
    "right": "16",
    "top": "16",
    "borderRadius": "8"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-8bfc90ae!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-card/index.vue
// module id = 521
// module chunks = 0 1